import { Controller } from 'stimulus'

export default class FocusController extends Controller {
  static targets = [ 'form']

  connect() {
    const firstInput = 'input:text:first:visible'
    $(this.formTarget).find(firstInput).focus()
  }
}
